import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { PriceLogBaseModel } from "../log/priceLogBaseModel"

@Serializable
export class PriceLogPagingModel {
  rows: PriceLogBaseModel[] = []
  numRows: number = 0

  constructor(
    data: {
      rows: PriceLogBaseModel[]
      numRows: number
    } | null = null,
  ) {
    if (data) {
      this.rows = data.rows
      this.numRows = data.numRows
    }
  }
}
